import React from "react";

function Navbar() {
  return (
    <div>
      <nav className="bg-white border-gray-200 dark:bg-gray-900 ">
        <div className="flex flex-wrap justify-between items-center mx-11 max-w-screen-xl h-14 pl-1 ">
          <h1 className="text-xl text-white font-semibold">
            Indomega alumunium
          </h1>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
